import React, { useState, useEffect } from 'react';
import data from '../constants.json';

const Projects = () => {
  const [showAll, setShowAll] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  // Listen for screen resize to handle responsiveness dynamically
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const visibleProjects = isMobile && !showAll ? Object.values(data.data).slice(0, 5) : Object.values(data.data);

  return (
    <section className="border-b border-gray-300 pb-12 px-6 ">
      <h2 className="my-16 text-center lg:text-left text-4xl font-bold text-[#703D99]">
        Projects
      </h2>

      <div className="grid gap-10 justify-center">


        {visibleProjects.map((e, index) => (
          <div 
            key={index} 
            className="flex flex-col lg:flex-row items-center lg:items-start gap-6 lg:gap-10 bg-gray-100 p-6 rounded-xl shadow-md border border-gray-300 hover:shadow-lg transition duration-300"
          >
            {/* Project Image - Ensuring Full Visibility */}
            <div className="w-60 h-auto lg:w-72 flex-shrink-0 overflow-hidden rounded-lg">
              <img
                src={e.img}
                alt={e.name}
                className="w-full h-full object-contain cursor-pointer transition-transform duration-300 hover:scale-105 rounded-lg"
                onClick={() => window.open(e.link, '_blank')}
              />
            </div>

            {/* Project Details */}
            <div className="text-center lg:text-left flex-1">
              <h3 className="text-2xl font-medium text-gray-900">{e.name}</h3>
              <p className="mt-2 text-gray-600">{e.dis}</p>

              {/* Tech Stack */}
              <div className="flex flex-wrap justify-center lg:justify-start gap-2 mt-4">
                {e.stack.map((t, idx) => (
                  <span 
                    key={idx} 
                    className="bg-gray-200 text-gray-700 px-3 py-1 text-sm font-medium rounded-md"
                  >
                    {t}
                  </span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Show More Button */}
      {isMobile && !showAll && (
        <div className="text-center mt-8">
          <button 
            className="bg-gray-800 text-white px-5 py-2.5 rounded-lg text-lg font-medium hover:bg-gray-700 transition duration-300"
            onClick={() => setShowAll(true)}
          >
            Show More
          </button>
        </div>
      )}
    </section>
  );
};

export default Projects;
